var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgColor = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_24597_53212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7512 10.5866C14.4814 10.2672 14.0787 10.2708 13.8126 10.5933C13.3019 11.2125 12.5565 12.2694 12.5565 13.0912C12.5565 14.3773 13.3735 15.1986 14.2783 15.2433C15.0582 15.2812 16 14.4763 16 13.0912C16 12.2254 15.2617 11.191 14.7512 10.5866ZM5.31325 15.2433C5.63865 15.5687 6.07081 15.7478 6.53051 15.7478C6.99021 15.7478 7.42236 15.5687 7.74777 15.2433L13.1652 9.82592C13.5013 9.48978 13.5013 8.94479 13.1652 8.60866L6.53051 1.97396L5.16518 0.60863C4.82904 0.272492 4.28405 0.272493 3.94792 0.60863C3.61178 0.944767 3.61178 1.48975 3.94792 1.82589L4.60614 2.48412C4.99667 2.87464 4.99667 3.5078 4.60614 3.89833L0.504466 8.00003C0.179059 8.32543 0 8.75759 0 9.21729C0 9.67699 0.179059 10.1091 0.504466 10.4345L5.31325 15.2433ZM5.8234 5.11559C6.21392 4.72507 6.84709 4.72507 7.23762 5.11559L9.63219 7.51018C10.2622 8.14015 9.81599 9.21729 8.92508 9.21729H4.13593C3.24503 9.21729 2.79886 8.14015 3.42882 7.51018L5.8234 5.11559Z",
    fill: "#5C5F62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24597_53212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/color.24e70808.svg";
export { ForwardRef as ReactComponent };